import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import * as _ from "lodash";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { ButtonBase, Grid, Typography } from "@material-ui/core";
import { sto } from "../../../Context/InshData";
import HeaderVo from "./HeaderVo";
import Body from "./Body";

function BillPage(props) {
    const { found, } = props;

    return (
        <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_page }}>
            <Fragment>
                <Grid xs={12} item >
                <HeaderVo info={found}  />
                    <Body
                       info={found}
                    />
                </Grid>
            </Fragment>
        </Grid>
    );
}

function VoucharCon(props) {
    const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
    const [found, setFound] = useState({});

    const [loading, setLoading] = useState(true);
    const [chunks, setChunks] = useState([]);

    const getInfo = async () => {
        const tb = {
            GetFoundation: true,
            wait: true,
            parms: {
                ibranchid: sto.branchi,
                branch: sto.branchi,
                iFoundid: 1,
            },
            autos: {},
        };
        console.log(tb);
        await axios
            .post(`${uri}Res`, tb)
            .then((res) => {
                setFound(res.data.Found);
            })
            .catch((error) => {
                console.log("catch");
            });
    };

    useEffect(() => {
        setTimeout(async () => {
            await getInfo();
            setLoading(false);
        }, 0);
    }, []);

    if (!found || loading) return <LoadingPage />;

    return (
        <Typography component="div" justifyContent="center" style={stElemnt.AF.Reviws.ReviwsJard}>
            <Typography component="div" >
                <BillPage
                    {...{
                        found,
                    }}
                />
            </Typography>
        </Typography>
    );
}
export default VoucharCon;
